import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Checkbox, Container, Grid } from 'semantic-ui-react'
import { isChaptersMode } from 'utils/functions'
import { removeIDFromMeta, validateMeta } from './lib/utils'
import css from './Processing.module.sass'

class Processing extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      moveEventsOnly: isChaptersMode()
    }

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.handleProcessingButton = this.handleProcessingButton.bind(this)
  }

  handleCheckboxChange (e, data) {
    this.setState({moveEventsOnly: data.checked})
  }

  handleProcessingButton () {
    const { moveEventsOnly } = this.state
    const {
      editData,
      onProcessing
    } = this.props
    const meta = removeIDFromMeta(Object.values(editData))

    meta.sort((a, b) => a.dts - b.dts)
    onProcessing(meta, validateMeta(meta), moveEventsOnly)
  }

  render () {
    const { moveEventsOnly } = this.state
    const { notificationStatus } = this.props

    return (
      <Container className={css.sendBtnContainer}>
        <Grid centered>
          <Grid.Row centered columns={1}>
            <Grid.Column textAlign='center'>
              <Checkbox
                label='Обработать только файл событий'
                checked={moveEventsOnly}
                disabled={isChaptersMode()}
                onChange={this.handleCheckboxChange}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row centered columns={1}>
            <Grid.Column textAlign='center'>
              <Button
                color='orange'
                type='button'
                icon='right arrow'
                labelPosition='right'
                content='Отправить на обработку'
                onClick={this.handleProcessingButton}
                disabled={!!notificationStatus}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}

const {
  func,
  object,
  string,
  oneOfType
} = PropTypes

Processing.propTypes = {
  editData: object.isRequired,
  onProcessing: func.isRequired,
  notificationStatus: oneOfType([
    string,
    object
  ])
}

export default Processing



// WEBPACK FOOTER //
// ./src/components/Processing/Processing.js